export default {
  cardButton: {
    clickVisualizar: "Clique para visualizar",
    rs: "R$"
  }
};
